export default __webpack_public_path__ + "static/media/ch_3.cdd5b459.mp3";